import { FC, SVGProps } from 'react'

export const BanxToken: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y="0.5" width="16" height="16" rx="8" fill="#98EC2D" />
    <path
      d="M11.1322 8.50103L12.606 10.5796L12.6089 10.583L9.96272 12.5H2L2.0132 12.4767L5.50502 6.42386H7.47016L5.07418 10.5761L9.76746 10.5775L9.76677 10.5761L8.2936 8.49965L10.7764 6.69899L11.1565 6.42386H7.47016L7.47989 6.40607L8.57782 4.50342H8.59518L9.41167 4.5H11.5464L11.5471 4.50137L12.6367 4.50205L13.9806 6.39375L14 6.42112L11.1322 8.50103Z"
      fill="black"
    />
  </svg>
)
